import { jsonToInputParams } from 'library/util/graph';

const buildSearchParams = (search_params) => (
  jsonToInputParams({query_string: search_params})
);

const searchOutcomes = (search_params) => ( `
{
  search_outcomes(${buildSearchParams(search_params)}) {
    id
    name
    description
    color

    goals {
      id
      name
      description
      steps_count

      steps {
        id
        name
        description
      }

      icon {
        id
        category
        action
        filename
      }
    }
  }
}
`);

export default searchOutcomes;
